import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { QuestionnaireShape } from 'entities';
import * as actions from 'actions';
import { getFeedQuestionnairesIsSubmitting } from 'selectors';

import Questionnaire from 'components/Questionnaire';
import Button from 'components/Button';
import './style.scss';

class FeedQuestionnaire extends Component {
  constructor() {
    super();

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.onQuestionnaireSubmit(this.props.questionnaire);
  }

  render() {
    const { questionnaire, onQuestionAnswer, isSubmitting } = this.props;
    const questionsWithNoAnswer = this.props.questionnaire.questions.filter(question => {
      // If question is required
      if (!question.hasOwnProperty('required') || question.required === true) {
        if (question.type !== 'radio') {
          // If answer is null or answer length is less than 1 then no answer
          if (question.type === 'checkbox') {
            return question.answer === null || !question.answer.length;
          }
          return question.answer === null || question.value === null || !question.value.length;
        }
        // Otherwise if answer is null then no answer
        return question.answer === null;
      }
      // If not required then no further check required
      return false;
    });
    const hasUnansweredQuestion = questionsWithNoAnswer.length > 0;

    return (
      <div className="FeedQuestionnaire">
        <h3>{__('members.feed.questionnaireTitle')}</h3>
        <Questionnaire
          metaHidden
          questionnaire={questionnaire}
          onQuestionAnswer={onQuestionAnswer}
        />
        <Button
          isYellow
          iconType="preloader-dark"
          hasIcon={isSubmitting}
          isDisabled={isSubmitting || hasUnansweredQuestion}
          onClick={this.handleSubmit}
        >
          {__('members.feed.questionnaireSubmit')}
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isSubmitting: getFeedQuestionnairesIsSubmitting(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onQuestionAnswer: (questionnaire, question, answer, value) => {
      dispatch(actions.feedQuestionUpdate(questionnaire.id, question.id, { answer, value }));
      dispatch(actions.feedQuestionnaireUpdate(questionnaire.id, { updatedAt: new Date() }));
    },
    onQuestionnaireSubmit: (questionnaire) => {
      dispatch(actions.feedQuestionnaireSubmit(questionnaire));
    }
  };
};

FeedQuestionnaire.propTypes = {
  questionnaire: QuestionnaireShape,
  onQuestionAnswer: PropTypes.func,
  onQuestionnaireSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeedQuestionnaire);




/** WEBPACK FOOTER **
 ** ./src/members/Main/Feed/FeedQuestionnaire/index.js
 **/